import classNames from 'classnames';
import React, { FCC } from 'react';
import { Icon } from '../Icon';
import colors from '../styles/colors.scss';
import './EmptyStateCard.scss';
import { IEmptyStateCardProps } from './types';

export const EmptyStateCard: FCC<IEmptyStateCardProps> = (props) => {
  const classList = classNames({
    [`hlc-empty-state-three-cards`]: props.icons.length === 3,
    [`hlc-empty-state-two-cards`]: props.icons.length === 2,
  });
  const defaultBackground =
    props.icons.length === 3 ? ['#F9AD69', colors.medGreen, colors.brightBlue] : ['#F9AD69', colors.brightBlue];

  const card = props.icons.map((item, index) => {
    return (
      <div key={index} className="hlc-empty-state-card">
        <div
          className="hlc-empty-state-card-top-part"
          style={{
            backgroundColor: item.background ? item.background : defaultBackground[index],
          }}
        >
          <Icon icon={item.icon} size={item.size ? item.size : '3x'} color={item.color ? item.color : 'white'} />
        </div>
        <div className="hlc-empty-state-card-bottom-part">
          <div />
          <div />
        </div>
      </div>
    );
  });

  return (
    <div className="hlc-empty-state-cards-wrapper" qa-id={props['qa-id']}>
      <div>
        <div className={classList}>{card}</div>
        <div className="hlc-empty-state-card-description">
          <h3>{props.primaryText}</h3>
          <div className="hlc-empty-state-card-secondary-text">{props.secondaryText}</div>
          {props.buttons}
        </div>
      </div>
    </div>
  );
};
